<template>
  <v-container
    id="formResults"
    fluid
    tag="section"
  >
    <v-card
      flat
      class="card-full-width"
    >
      <v-btn
        tile
        @click="doGetLogs"
        color="primary"
      >
        Refresh Logs
      </v-btn>
    </v-card>
    <v-card
      class="mx-4 px-4 py-4"
    >
      <v-data-table
        :items="logs"
        :server-items-length="totalLogs"
        :headers="headersFormResults"
        :options.sync="options"
        :loading="loading"
        fixed-header
        height="600"
      >
        <template v-slot:item.updated_at="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
              >
              {{ formatEpoch(item.updated_at, 'YYYY-MM-DD HH:mm:ss') }}
              </span>
            </template>
            <p>
              {{ formatEpoch(item.updated_at, 'ddd MMM DD, yyyy HH:mm:ss') }}
            </p>
            <p>{{ formatEpochFromNow(item.updated_at) }}</p>
          </v-tooltip>
        </template>
        <template v-slot:item.updated_by="{ item }">
          <v-list-item-content
            v-if="item.updated_by === '00000000-0000-0000-0000-000000000000'"
            class="align-end"
          >
            System
          </v-list-item-content>
          <v-list-item-content
            v-else
            class="align-end"
          >
            {{ item.updated_last_name }}, {{ item.updated_first_name}}
          </v-list-item-content>
        </template>
        <template v-slot:item.display_text="{ item }">
          {{ item.display_text}}
        </template>
        <template v-slot:item.fk_account_key="{ item }">
          <v-list-item-content
            v-if="item.fk_account_key && item.fk_account_key !== '00000000-0000-0000-0000-000000000000'"
            class="align-end"
          >
            <v-btn
              text
              :href="'/#/staff/account/' + item.fk_account_key"
              target="_blank"
              color="blue"
            >
              {{ item.acct_display_text }}
            </v-btn>
          </v-list-item-content>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
  import ActivityLogService from '../../../services/activity-log.service'
  import basicMixin from '../../../mixins/basic'

  export default {
    name: 'ActivityLogs',
    mixins: [basicMixin],

    data () {
      return {
        totalLogs: 0,
        logs: [],
        loading: true,
        options: {},
        headersFormResults: [
          {
            text: 'Timestamp',
            align: 'start',
            sortable: true,
            groupable: false,
            value: 'updated_at',
          },
          {
            text: 'By',
            align: 'start',
            sortable: true,
            groupable: false,
            value: 'updated_by',
          },
          {
            text: 'Category',
            align: 'start',
            sortable: false,
            groupable: false,
            value: 'category',
          },
          {
            text: 'Action',
            align: 'start',
            sortable: true,
            groupable: true,
            value: 'action',
          },
          {
            text: 'Details',
            align: 'start',
            sortable: true,
            groupable: true,
            value: 'display_text',
          },
          {
            text: 'Account',
            align: 'start',
            sortable: true,
            groupable: false,
            value: 'fk_account_key',
          },
        ],

      }
    },
    watch: {
      options: {
        handler (val, oldVal) {
          console.log('log options changed:', val)
          this.doGetLogs()
        },
        deep: true,
      },
    },
    computed: {
    },
    async created () {
      await this.doGetLogs()
    },
    mounted () {

      // const queryParams = this.$route.params
    },
    methods: {
      async doGetLogs () {
        this.loading = true
        try {
          const queryPayload = {
            page: this.options.page,
            pageSize: this.options.itemsPerPage,
          }
          const { data } = await ActivityLogService.query(queryPayload)
          this.totalLogs = 1000
          this.logs = data
        } catch (e) {
          alert('there was an error retrieving the latest form submissions')
          console.log(e)
        }
        this.loading = false
      },
    },
  }
</script>
